const feeddata = {
    //"url": "https://digitalwires.dpa-newslab.com/3oW9QB5peNOQcmpvc35O853BuB0GezSB/aufschaltung/au-clNDN37KE7BYFFntzj/feed/germany-today-all.json",
    "url": "https://digitalwires.dpa-newslab.com/VBD9sfK4WguyuFi8gcSAWcxQlP7pNOzn/aufschaltung/au-clmQwfxm8VaRZeV3Nb/feed/labline.json",
    "rubrics": ["weblines.labline.test2", "weblines.labline.test3"],
    "audiofolder": "https://d3u50a5rk9kmoq.cloudfront.net/audio/quotes/",
    "videofolder": "https://d3u50a5rk9kmoq.cloudfront.net/audio/quotes/",
    "select": entry => { return true; }
};

export {feeddata};